import store from './store/store';
import { updateZipcode } from './actions/zipcode';

export default function init() {
  const zipcodeCookie = localStorage.getItem('userZipCode');

  if (zipcodeCookie) {
    store.dispatch(updateZipcode({
      zipcode: zipcodeCookie,
    }));
  }
}
